module.exports = __webpack_public_path__ + "images/speed-six-default.994afd3a0bc1f9ad4f14c80d79d208c9.png";